import * as React from 'react';

import { Typography, Paper, LinearProgress } from "@material-ui/core";
import { ResponsiveContainer, Treemap, Tooltip } from 'recharts';
import { NumberPercent, NumberConvert } from '../../../../../services';


// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryProductVolumeProps {
    data: any;
    loading: boolean;
    type: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketShareBookstoreCategoryProductVolumeState {
}

export interface IMarketShareBookstoreCategoryProductVolumeDataChart {
    name: string;
    percent: number | null;
    value: number;
}

const dataFilled = (data: any) => {
    return data && data.marketCategoryBookstoreQtdProdsByCategory && !!data.marketCategoryBookstoreQtdProdsByCategory.length
}

const ColorPlatte = ['#FF6A14','#323232', '#90EE90','#20B2AA', '#FF8042', '#FFBB28',
'#FFB6C1', '#FFA07A', '#0088FE', '#87CEFA', '#778899', '#778899', '#B0C4DE',
'#008080', '#D8BFD8', '#FF6347', '#40E0D0', '#EE82EE', '#00C49F',
'#C3F500', '#FFBF00', '#84EA00', '#E768B0', '#33CECE', '#062671', '#422D86',
'#5DCFCA', '#B62E40', '#FF7600', '#F2B5B8'];

const CustomizedContent = ({ root, depth, x, y, width, height, index, name } : 
    {root:any, depth:number, x:number, y:number, width:number, height:number, index:number, name:string}) => (
    <g>
        <rect
            x={x}
            y={y}
            width={width}
            height={height}
            style={{
                fill: ColorPlatte[index % ColorPlatte.length],
                stroke: '#fff',
                strokeOpacity: 1 / (depth + 1e-10),
                strokeWidth: 2 / (depth + 1e-10),
            }}
        />
        <text
            x={x + width / 2}
            y={y + height / 2 + 7}
            textAnchor="middle"
            fill="#fff"
        >
            {name}
        </text>
    </g>
);

// statless component
const CustonTooltipData = (props: any) => {

    let content;
    props.payload !== null &&  props.payload.length !== undefined && props.payload.length > 0 ? content = props.payload[0].payload : content = undefined;

    return (<div className="tooltip-box">
        <table>
            <tbody>
            <tr className="tooltip-text">
                    <td className="tooltip-title" colSpan={2}> {content && content.name} </td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Quantidade:</td>
                    <td className="tooltip-content">{content && content.value}</td>
                </tr>
                <tr className="tooltip-text">
                    <td className="tooltip-title">Participação:</td>
                    <td className="tooltip-title">{content && content.percent ? content.percent.toFixed(2) : 0}%</td>
                </tr>
            </tbody>
        </table>
    </div>
    )
};

// statless component
const MarketShareBookstoreCategoryProductVolumeChart = ({ data } : 
    { data: IMarketShareBookstoreCategoryProductVolumeDataChart[] }) => (
    <div>
        <ResponsiveContainer width="100%" height={345}>
            <Treemap
                aspectRatio={4/3}
                content={CustomizedContent}
                data={data}
                nameKey="name"
                dataKey="value"
                stroke="#fff"
                fill="#8884d8"
            >
                <Tooltip content={<CustonTooltipData isAnimationActive={false}  />} />
            </Treemap>
        </ResponsiveContainer>
    </div>
);

export class MarketShareBookstoreCategoryProductVolume extends React.Component<IMarketShareBookstoreCategoryProductVolumeProps, IMarketShareBookstoreCategoryProductVolumeState> {

    public render() {
        const titleComplement = (this.props.type === 'market') ? ' - Mercado' : '';
        return  (
            <div>
                
                <Paper className="publisher-sale-block panel-block" >
                    <Typography variant="headline" className="panel-title" component="title">
                        Volume de Produtos por Categoria {titleComplement}
                    </Typography>

                    {
                        this.props.loading
                        ?
                        <LinearProgress />
                        :
                        (
                            dataFilled(this.props.data)
                            ?
                            (
                                <MarketShareBookstoreCategoryProductVolumeChart 
                                    data={this.convertData(this.props.data.marketCategoryBookstoreQtdProdsByCategory)}
                                />
                            )
                            :
                            (<Typography variant="body2" className="comparative" component="p">
                                Não há informações de vendas
                            </Typography>)
                        )
                    }
                </Paper>
                
            </div>
        )
    }

    private convertData = (data: any[]) => {

        const mappedData: IMarketShareBookstoreCategoryProductVolumeDataChart[] = [];

        if(data) {
            let total = 0;
            data.forEach(e => {
                total += (this.props.type === 'market') ? Number.parseFloat(e.qtd_market.toString()) : Number.parseFloat(e.my_qtd.toString());
            });

            data.forEach(e => {
                const val = (this.props.type === 'market') ? Number.parseFloat(e.qtd_market.toString()) : Number.parseFloat(e.my_qtd.toString());
                const item: IMarketShareBookstoreCategoryProductVolumeDataChart = {
                    name: e.category && e.category.length > 17 ? e.category.substr(0,17) : e.category,
                    percent: NumberPercent(total,NumberConvert(val.toString())),
                    value: val
                };
                mappedData.push(item);
            });
        }

        return mappedData;
    }

}



// WEBPACK FOOTER //
// ./src/component/market/bookstore/categoryShare/productVolumeByCategory/MarketShareBookstoreCategoryProductVolume.tsx